import { Component, EventEmitter, Inject, Output } from '@angular/core';
import {
  KeyString,
  KeyValue,
} from '../../../../../../projects/vendors/src/lib/services/form-helper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-ongoing-order-filter-dialog',
    templateUrl: './ongoing-order-filter-dialog.component.html',
    styleUrl: './ongoing-order-filter-dialog.component.scss',
    standalone: false
})
export class OngoingOrderFilterDialogComponent {
  @Output() filterChange = new EventEmitter<any>();

  orderTypeKeyValue = [] as KeyValue[];
  tableNameKeyValue = [] as KeyString[];
  userNameKeyValue = [] as KeyString[];
  sectionNameKeyValue = [] as KeyString[];
  orderStatusKeyValue = [] as KeyValue[];
  selectedOrderType!: number;
  selectedTableName!: string[];
  selectedSectionName!: string[];
  selectedUser!: string;
  selectedOrderStatus!: number;
  searchValue!: any;
  private searchTimeout: any;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      tableNameKeyValue: KeyString[];
      userNameKeyValue: KeyString[];
      sectionNameKeyValue: KeyString[];
      orderStatusKeyValue: KeyValue[];
      orderTypeKeyValue: KeyValue[];
      selectedFilters: {
        orderType: number;
        tableName: string[];
        sectionName: string[];
        userName: string;
        orderStatus: number;
        searchValue: string
      };
    },
    private dialogRef: MatDialogRef<OngoingOrderFilterDialogComponent>
  ) {
    this.orderTypeKeyValue = this.data.orderTypeKeyValue;
    this.tableNameKeyValue = this.data.tableNameKeyValue;
    this.userNameKeyValue = this.data.userNameKeyValue;
    this.sectionNameKeyValue = this.data.sectionNameKeyValue;
    this.orderStatusKeyValue = this.data.orderStatusKeyValue;

    this.selectedOrderType = this.data?.selectedFilters.orderType;
    this.selectedTableName = this.data?.selectedFilters.tableName;
    this.selectedSectionName = this.data?.selectedFilters.sectionName;
    this.selectedUser = this.data?.selectedFilters.userName;
    this.selectedOrderStatus = this.data?.selectedFilters.orderStatus;
    this.searchValue = this.data?.selectedFilters.searchValue;

  }

  emitFilterData() {
    const filterData = {
      orderType:  this.selectedOrderType,
      tableName: this.selectedTableName,
      sectionName: this.selectedSectionName,
      userName:  this.selectedUser,
      orderStatus: this.selectedOrderStatus,
      searchValue:  this.searchValue
    };
    this.filterChange.emit(filterData);
  }

  onSelectOrderType(orderType: number){
    this.selectedOrderType = orderType;
    this.emitFilterData();
  }

  onTableName(data: string[]){
    this.selectedTableName = data;
    this.emitFilterData();
  }

  onSectionName(data: string[]){
    this.selectedSectionName = data;
    this.emitFilterData();
  }

  onSelectUser(user : string){
    this.selectedUser = user;
    this.emitFilterData();
  }

  onSelectStatus(status: number){
    this.selectedOrderStatus = status;
    this.emitFilterData();
  }

  liveSearch() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.emitFilterData();
    }, 3000);
  }

  onSubmit() {
    this.dialogRef.close();
  }
}
